import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 85vh;
`;

export const LoginButtonPosition = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 85vh;
`;
